// import TopBar from 'Common/Header/TopBar'


import React from 'react'
import SuperAdminLayout from 'SuperAdmin/SuperAdminLayout/SuperAdminLayout'
import SuperAdminCard from './SuperAdminCard'

const SuperAdminHome = () => {
 



  return (<>


    <SuperAdminLayout>


        <SuperAdminCard/>


    </SuperAdminLayout>


  </>)
}

export default SuperAdminHome